import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { EMPTY as observableEmpty } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LoginStorage } from '../../login/login.storage';
import { Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../login/login.storage";
import * as i3 from "@angular/router";
export class OmniFacilUploadRestService {
    constructor(http, loginStorage, router) {
        this.http = http;
        this.loginStorage = loginStorage;
        this.router = router;
    }
    post(fileOrFileList, proposta, typeDocument, configTokenProposta) {
        if (this.loginStorage.isTokenExpired()) {
            this.router.navigate(['/login']);
            return observableEmpty;
        }
        const configToken = {
            login: this.loginStorage ? this.loginStorage.login : '',
            token: this.loginStorage ? this.loginStorage.token : '',
        };
        const formData = new FormData();
        formData.append('data', JSON.stringify(this.getBody(proposta, typeDocument, configTokenProposta || configToken)));
        if (fileOrFileList instanceof FileList) {
            Array.from(fileOrFileList).forEach((file) => formData.append('file', file, file.name));
        }
        else {
            formData.append('file', fileOrFileList, fileOrFileList.name);
        }
        return this.http.post(`${this.getBaseUrl()}file/ext/upload`, formData);
    }
    buscarDocumentosPorProposta(propostaId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.loginStorage.isTokenExpired()) {
                this.router.navigate(['/login']);
                return observableEmpty.toPromise();
            }
            const configToken = {
                login: this.loginStorage ? this.loginStorage.login : '',
                token: this.loginStorage ? this.loginStorage.token : '',
            };
            const pesquisa = {
                indices: [
                    {
                        indiceType: 1,
                        indiceValue: `${propostaId}`
                    }
                ],
                originID: -1,
                token: configToken.token,
                userName: configToken.login,
                ordenaDataDesc: true,
                utilizaUnion: false
            };
            const retorno = yield this.http.post(`${this.getBaseUrl()}file/ext/list/generic`, pesquisa).toPromise();
            return retorno.files.map(file => ({
                url: `${retorno.downloadUrl}${file.id}`,
                thumbUrl: `${retorno.downloadThumbUrl}${file.id}`,
                name: file.name,
                idDocto: file.fileType.id
            }));
        });
    }
    getBaseUrl() {
        return environment.URL_OMNI_DOC_UPLOAD;
    }
    getBody(proposta, typeDocument, configTokenProposta) {
        const INDICE_PROPOSTA = 1;
        const INDICE_CONTRATO = 2;
        const INDICE_CPF = 3;
        const indices = [
            {
                indiceType: INDICE_PROPOSTA,
                indiceValue: proposta.id,
            }
        ];
        if (proposta.numeroPreContrato) {
            indices.push({
                indiceType: INDICE_CONTRATO,
                indiceValue: proposta.numeroPreContrato,
            });
        }
        if (proposta.cliente) {
            indices.push({
                indiceType: INDICE_CPF,
                indiceValue: proposta.cliente.cpf,
            });
        }
        return {
            indices,
            typeDocument,
            userName: configTokenProposta.login,
            userID: configTokenProposta.token,
            departmentID: proposta.origem,
            document: proposta.id,
            typeFile: typeDocument,
        };
    }
}
OmniFacilUploadRestService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function OmniFacilUploadRestService_Factory() { return new OmniFacilUploadRestService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.LoginStorage), i0.ɵɵinject(i3.Router)); }, token: OmniFacilUploadRestService, providedIn: "root" });
